import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IComboBase } from '../interfaces/base/base.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AmountRenewalContractsService {
  private apiUrl = `${environment.apiUrl}/amountRenewalContracts`;

  constructor(private http: HttpClient) {}

  comboAmountRenewalContracts(): Observable<IComboBase[]> {
    return this.http.get<IComboBase[]>(this.apiUrl + '/combo');
  }
}
